module.exports = __webpack_public_path__ + "img/banner_campanie_vn.b7de73c7.png";